/* eslint-disable prettier/prettier */
import { axiosTNL } from "./axiosInstance";

export default {
    // eslint-disable-next-line prettier/prettier
    uploadFile: async function (formdata) {
        return axiosTNL.post("order/UploadFileToS3", formdata);
    }

};